// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1gO-F","footer":"ModalInfo_footer__vD4d_"};